import { get, post } from '../services/common/common.service';
import { warrantyInforTab } from '../constants/endpoint';

//use to get serial history table initial loading, after swapping with eid , after swap modal
export const fetchSerialNoHistory = (payload) =>
  get(`${warrantyInforTab.getSerialNoHistory}?warrantyId=${payload}`, payload);

// use to get warranties data in rqs modal on basis of entitlement id
export const rqsModal = (payload) => {
  return post(warrantyInforTab.rqsModal, payload);
};

//to search warranties in rqsmodal
export const searchWarranties = (payload)=>{
  return post(warrantyInforTab.searchWarranties,payload);
}

//swap api on basis of eid using rqsmodal table
export const warrantyPartNoChange = (payload) => {
  return post(warrantyInforTab.wpnChange, payload);
};

//to get serial swap no info of popup
export const serialNoInfo = (payload) => {
  return get(
    `${warrantyInforTab.getSerialNoInfo}?warrantyPartNo=${payload}`,
    payload
  );
};

//search  filters by sr no,eid,rqs id in swap modal
export const searchSerialNo = (payload) => {
  return post(warrantyInforTab.searchSrNoFilters, payload);
};
//swap SR from Esr
export const swappingEsr = (payload) => {
  return post(
    `${warrantyInforTab.swapEsr}?&currentEntitlementId=${payload?.currentEntitlementId}&swapEntitlementId=${payload?.swapEntitlementId}&userId=${payload?.userId}`
  );
};